/* eslint-disable no-multi-str */
import React from "react"
import { faBook, faBolt, faUserFriends } from "@fortawesome/free-solid-svg-icons"

import SectionContainer from "../components/SectionContainer"
import CollapsableSkillHead from "../components/CollapsableSkillHead"
import DropDown from "../components/DropDown"
import CollapsableCard from "../components/CollapsableCard"

const skills = [
  {
    name: "Leadership",
    icon: faBolt,
    iconcolor: "var(--honey-yellow)",
    adjective: "Motivated",
    description: "Making decisions and taking initiative",
    customtext: "The success of a project often depends on the competency \
                of the leader. A good leader empowers everyone to do their \
                best work. Having strong leadership and direction also allows \
                the team to focus on their tasks and not worry about unnecessary \
                details.",
  },
  {
    name: "Management",
    icon: faUserFriends,
    iconcolor: "var(--queen-blue)",
    adjective: "Experienced",
    description: "Collaborative work needs a focused direction",
    customtext: "In most team projects I've worked on, I've stepped \
                up and taken the responsibility of managing the \
                workflow. Planning timelines, managing available resources, \
                delegating tasks to the right team member - it all makes \
                a huge difference to the productivity of the team \
                and the success of the project.",
  },
  {
    name: "Teaching",
    icon: faBook,
    iconcolor: "var(--spanish-green)",
    adjective: "Passionate",
    description: "Knowledge spreads through sharing",
    customtext: "I've taught web development fundamentals \
    several times to early talent hires at work. I've taught \
    software design and architecture to teammates who were new \
    to software development. I find it very satisfying to pass \
    along what I know, and it's always a good test of my own \
    knowledge when people ask in-depth questions.",
  }
]

const Components = () =>
  <>
  {skills.map((skill, index) => {
    const Head = 
      <CollapsableSkillHead
        name={skill.name}
        icon={skill.icon}
        iconcolor={skill.iconcolor}
        proficiency={skill.adjective}
      />
    
    const Drop =
      <DropDown
        description={skill.description}
        customtext={skill.customtext}
      />

    return (
      <CollapsableCard
        head={Head}
        dropdown={Drop}
        key={index}
      />
    )
  })}
  </>

const GeneralSkills = () =>
  <SectionContainer header="General">
    <Components />
  </SectionContainer>

export default GeneralSkills
